<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <v-form ref="companyProfileForm" @submit.prevent="saveCompanyProfile" class="custom-form">
                    <v-card :elevation="1" color="blue lighten-5">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-toolbar color="#546E7A" dark :elevation="1" height="30px">
                                    <v-toolbar-title class="subtitle-2">Company Profile</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text class="py-2 mt-1">
                                    <v-row dense justify="center">
                                        <v-col cols="5">
                                            <v-row no-gutters class="mb-2">
                                                <v-col cols="4">Company Name</v-col>
                                                <v-col cols="8">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        :rules="[v => !!v]"
                                                        v-model.trim="company.company_name"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-2">
                                                <v-col cols="4">Address</v-col>
                                                <v-col cols="8">
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        hide-details
                                                        v-model.trim="company.address"
                                                        height="8vh"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-2">
                                                <v-col cols="4">Contact Us</v-col>
                                                <v-col cols="8">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        v-model.trim="company.contact_us"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-2">
                                                <v-col cols="4">E-mail</v-col>
                                                <v-col cols="8">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        v-model.trim="company.email"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-2">
                                                <v-col cols="4">Company Logo</v-col>
                                                <v-col cols="8">
                                                    <v-file-input 
                                                        show-size 
                                                        outlined 
                                                        dense
                                                        hide-details
                                                        @change="onChangeMainImage()"
                                                        prepend-icon=""
                                                        prepend-inner-icon="mdi-camera"
                                                    >
                                                    </v-file-input>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-2">
                                                <v-col cols="4"></v-col>
                                                <v-col cols="8">
                                                    <v-card tile :elevation="0"> 
                                                        <v-img
                                                            :src="image"
                                                            aspect-ratio="1.9"
                                                            class="grey lighten-2"
                                                            contain
                                                        >
                                                        </v-img>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col cols="4"></v-col>
                                                <v-col cols="8">
                                                    <v-row no-gutters>
                                                         <v-col cols="6" class="pr-1">
                                                            <v-btn @click="resetForm" height="30px" dark block color="deep-orange">Clear</v-btn>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-btn type="submit" :loading="waitingForSave" height="30px" dark block color="light-blue darken-2">Save</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'CompanyProfile',
    data: ()=> ({
        company: {
            company_name: '',
            address: '',
            contact_us: '',
            email: ''
        },
        image: '',
        imageFile: null,

        waitingForSave: false,
    }),
    async created() {
        await this.$store.dispatch('companyProfile/getCompanyProfile')
        this.company.company_name = this.$store.getters['companyProfile/company'].company_name
        this.company.address = this.$store.getters['companyProfile/company'].address
        this.company.contact_us = this.$store.getters['companyProfile/company'].contact_us
        this.company.email = this.$store.getters['companyProfile/company'].email
        this.image = this.$store.getters['companyProfile/company'].image ? window.apiBaseURL +`/`+ this.$store.getters['companyProfile/company'].image : ''
    },
    methods: {
        async saveCompanyProfile() {
            if (!this.$refs.companyProfileForm.validate()) return
            this.waitingForSave = true
            let res = await this.$store.dispatch('companyProfile/saveCompanyProfile', { company: this.company, image: this.imageFile })
            this.waitingForSave = false
        },

        onChangeMainImage() {
            if(event.target.files == undefined || event.target.files.length < 1) {
                this.image = '';
                this.imageFile = null;
                return;
            }

            this.imageFile = event.target.files[0];
            this.image = URL.createObjectURL(event.target.files[0]);
        },
        
        resetForm() {
            Object.keys(this.company).map(k => this.company[k] = '')
            this.$refs.companyProfileForm.resetValidation()
        }
    }
}
</script>

<style lang="scss" scoped>
    .v-icon.v-icon {
       font-size: 18px !important;
       top: -3px !important;
    }
    .v-icon.v-icon[data-v-1f38b4e5] {
        font-size: 14px !important;
        top: 0px !important; 
    }
    .v-messages {
        flex: 1 1 auto;
        font-size: 12px;
        min-height: 0px !important;
        max-height: 0px!important;
        min-width: 1px;
        position: relative;
    }
</style>